import { ComponentErrorBoundary } from '../../utilities/ComponentErrorBoundary';
import { useFormContext } from 'react-hook-form';
import React, { DetailedHTMLProps } from 'react';

import { BaseFromProps } from './BaseFromProps';

export function CheckBox<T>({
  label,
  checkboxOptions,
  name,
  options,
  width,
  defaultValue,
  ...props
}: CheckBoxProps<T>) {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  return (
    <ComponentErrorBoundary>
      <div className={`${width || 'sixteen'} wide column`}>
        <div className={'fields'}>
          <div className="ui labeled input">
            <div className={'ui label'} style={{ marginRight: '10px' }}>
              {label}
            </div>
            {checkboxOptions.map((option) => (
              <div key={option} className={'ui checkbox'} style={{ marginRight: '10px' }}>
                <input
                  id={option}
                  type={'checkbox'}
                  defaultChecked={defaultValue?.includes(option)}
                  value={option}
                  placeholder={option}
                  {...register(name, options)}
                  {...props}
                />
                <label htmlFor={option}>{option}</label>
              </div>
            ))}
          </div>
          {!!errors[name] && <div className="ui pointing red basic label">{errors[name]?.message as string}</div>}
        </div>
      </div>
    </ComponentErrorBoundary>
  );
}

export type CheckBoxProps<T> = {
  checkboxOptions: string[];
  defaultValue: string[];
} & BaseFromProps<T> &
  DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;
